import axios from "axios";
import { API_GATEWAY, PR_DEP } from "../../config/globalVariables";

class AffiliateService {
  getList() {
    return axios
      .get(`${API_GATEWAY + PR_DEP}/affiliate/get-list`)
      .then((response) => {
        return response.data;
      });
  }
}

export default new AffiliateService();
